(function ($) {

    let last_ajax_request;

    function updateReturnSummary() {
        let $form = $('form[data-form-id="return-registration"]');

        let url = $form.attr('action') + "&action=return_registration_summary",
            data = $form.serializeArray()

        // remove action to prevent collision in ajax
        data = data.filter((item) => item.name !== 'action');

        if(last_ajax_request){
            last_ajax_request.abort();
        }

        last_ajax_request = gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            show_loading: false,
            data: data
        });
    }

    function updateReasonDetail($radio) {
        const $wrapper = $radio.closest('.my-account-return__products__item_dropdown');
        const selectedGroup = String($radio.val());

        $wrapper.find('[data-reason-detail]').each(function () {
            const $detail = $(this);
            const isMatch = String($detail.data('group')) === selectedGroup;
            $detail.prop('hidden', !isMatch);
            if (!isMatch) {
                $detail.find('textarea, input').val('');
            }
        });
    }

    function reasonHasDetail($wrapper, groupId) {
        return $wrapper.find(`[data-reason-detail][data-group="${groupId}"]`).length > 0;
    }

    function collapseReasonDropdown($wrapper) {
        $wrapper.find('.my-account-return__products__item_dropdown-body').prop('hidden', true);
        $wrapper.find('.my-account-return__products__item_dropdown-toggle').attr('aria-expanded', 'false');
        $wrapper.removeClass('is-open');
    }

    function expandReasonDropdown($wrapper) {
        $wrapper.find('.my-account-return__products__item_dropdown-body').prop('hidden', false);
        $wrapper.find('.my-account-return__products__item_dropdown-toggle').attr('aria-expanded', 'true');
        $wrapper.addClass('is-open');
    }

    function updateReasonSummary($radio, { collapse = true } = {}) {
        const $wrapper = $radio.closest('.my-account-return__products__item_dropdown');
        const $label = $wrapper.find('.my-account-return__products__item_dropdown-toggle-label');
        const selectedGroup = String($radio.val());

        $wrapper.find('[data-reason-summary]').each(function () {
            const $summary = $(this);
            const isMatch = String($summary.data('reason-summary')) === selectedGroup;
            $summary.prop('hidden', !isMatch);
        });

        $label.toggleClass('is-filled', true);

        if (collapse) {
            collapseReasonDropdown($wrapper);
        }
    }

    $('form[data-form-id="return-registration"]')
        .on('change', 'input[name$="[return]"]', function () {
            let $checkbox = $(this),
                $reasonSection = $checkbox.closest('.order-return-item').find('.order-return-item__reason');

            if ($checkbox.is(':checked')) {
                $reasonSection.removeAttr('hidden');
            } else {
                $reasonSection.attr('hidden', '');
            }

            updateReturnSummary();
        })
        .on('input', 'input[type="number"][name*="quantity"]', updateReturnSummary)
        .on('change', 'input[name$="[reason]"]', function () {
            const $radio = $(this);
            const $wrapper = $radio.closest('.my-account-return__products__item_dropdown');

            updateReasonDetail($radio);

            const needsDetail = reasonHasDetail($wrapper, $radio.val());
            updateReasonSummary($radio, { collapse: !needsDetail });
        })
        .on('click', '.my-account-return__products__item_dropdown-form-button', function (e) {
            e.preventDefault();

            const $wrapper = $(this).closest('.my-account-return__products__item_dropdown');
            const $detailBox = $(this).closest('[data-reason-detail]');
            const groupId = String($detailBox.data('group'));
            const detailValue = ($detailBox.find('textarea, input').val() || '').trim();

            const $summary = $wrapper.find(`[data-reason-summary="${groupId}"]`);
            const baseLabel = $summary.data('reason-label') || $summary.text().trim();

            $summary.text(detailValue ? `${baseLabel} - ${detailValue}` : baseLabel);

            collapseReasonDropdown($wrapper);
        })
        .on('click', '.my-account-return__products__item_dropdown-toggle', function (e) {
            e.preventDefault();
            const $wrapper = $(this).closest('.my-account-return__products__item_dropdown');
            if ($wrapper.hasClass('is-open')) {
                collapseReasonDropdown($wrapper);
            } else {
                expandReasonDropdown($wrapper);
            }
        });

    $('[data-return-quantity-action]').on('click', function () {
        let action = $(this).data('return-quantity-action'),
            $input = $(this).siblings('input[type="number"]'),
            current_qty = parseInt($input.val());

        if (action === 'plus') {
            let max = $input.attr("max") ? parseInt($input.attr("max")) : 0;
            if (!max || current_qty < max) {
                $input.val(current_qty + 1).trigger('change');
            }
        } else if (action === 'minus') {
            let min = $input.attr("min") ? parseInt($input.attr("min")) : 1;
            if (current_qty > min) {
                $input.val(current_qty - 1).trigger('change');
            }
        }
    });

    // we have multiple inputs with the same name, so we need to update all of them
    $('.order-return-item input[type="number"]').on('change', function () {
        let $this = $(this);
        $this.closest('.order-return-item').find('input[name="' + $this.attr('name') + '"]').not($this).val($this.val());

        updateReturnSummary.call(this);
    });

})(jQuery);